import { Cookie } from 'core-events/components';
import { createLogger } from 'logging';
import { useCallback } from 'react';

import { GoogleLoginSuccessCallback } from '../../../components/google-login/useGoogleLoginIFrameEventListener';
import { getCookie } from '../../../components/lib/cookies/getCookie';
import { RecaptchaAction } from '../../../components/recaptcha/RecaptchaAction';
import { useGoogleCallback } from '../../../components/recaptcha/useGoogleCallback';
import { useSignUpContext } from './SignUpContext';
import { SignUpFormPayload } from './SignUpFormPayload';
import { signUpAction } from './signUpAction';

const logger = createLogger('useGoogleSignUpCallback');

export function useGoogleSignUpCallback(planCode?: string): GoogleLoginSuccessCallback {
    const { setError, setSubmitText } = useSignUpContext();

    const handleSuccess = useCallback(
        async (googleCredential: string, recaptchaToken: string | undefined) => {
            const uniqueId = getCookie(Cookie.Vid);
            try {
                const result = await signUpAction({
                    signupType: 'google',
                    uniqueId,
                    googleCredential,
                    planCode,
                    recaptchaToken,
                } satisfies SignUpFormPayload);

                if (result && result?.error) {
                    setError(result.error);
                    setSubmitText('Create Account');
                }
            } catch (e) {
                logger.error(e);
                setError('Oops! Something went wrong. Please try again.');
                setSubmitText('Create Account');
            }
        },
        [setError, setSubmitText, planCode],
    );

    const handleError = useCallback(
        (error: Error) => {
            logger.error(error);
            setError('Oops! Something went wrong. Please try again.');
            setSubmitText('Create Account');
        },
        [setError, setSubmitText],
    );

    return useGoogleCallback({
        action: RecaptchaAction.SIGN_UP_WITH_GOOGLE,
        onSuccess: handleSuccess,
        onError: handleError,
    });
}
